import React from 'react';
import { ButtonType } from '../../../types/ButtonType';
import { SVGIcon } from '../../../components/atoms/SVG';
import { BtnModifier } from '../../../components/molecules/Btn';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { Button } from '../../../components/molecules/Btn/Button';
import { ButtonProps } from '../../../types/HtmlProps';

type BlockBarButtonProps = ButtonProps & {
  onClick: () => void;
  text: string;
  svgSpriteId: SVGIcon;
  buttonType?: ButtonType;
  ref?: React.RefObject<HTMLButtonElement | null>;
};

export function BlockBarButton({
  onClick,
  text,
  svgSpriteId,
  buttonType = ButtonType.BUTTON,
  ref,
  ...props
}: BlockBarButtonProps) {
  return (
    <div className="block-bar__button">
      <Button
        ref={ref}
        onClick={onClick}
        tooltipPlacement={TooltipPlacement.TOP}
        type={buttonType}
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        title={text}
        hideTooltipFromScreenReader
        {...props}
      >
        <Button.Icon svgSpriteId={svgSpriteId} text={text} />
      </Button>
    </div>
  );
}
